import Config from '../config/index'


const children = [{ // 首页
		path: '/pages/index/index',
		name: 'index',
		component: r => require.ensure([], () => r(require('../views/pages/index/index'))),
		meta: {}
	},
	{ // 游戏
		path: '/pages/game/game',
		name: 'game',
		component: r => require.ensure([], () => r(require('../views/pages/game/game'))),
		meta: {}
	},
	{ // 会员管理
		path: '/pages/member/list',
		name: 'member_list',
		component: r => require.ensure([], () => r(require('../views/pages/member/list'))),
		meta: {}
	},
	{ // 订单管理-列表
		path: '/pages/order/list',
		name: 'order_list',
		component: r => require.ensure([], () => r(require('../views/pages/order/list'))),
		meta: {}
	},
	{ // 订单管理-图标
		path: '/pages/order/chart',
		name: 'order_chart',
		component: r => require.ensure([], () => r(require('../views/pages/order/chart'))),
		meta: {}
	},
	{ // 订单管理-图标
		path: '/pages/user/list',
		name: 'user_list',
		component: r => require.ensure([], () => r(require('../views/pages/user/list'))),
		meta: {}
	},
	{ // 商品管理-区服管理
		path: '/pages/commodity/category',
		name: 'commodity_category',
		component: r => require.ensure([], () => r(require('../views/pages/commodity/category'))),
		meta: {}
	},
	{ // 商品管理-商品列表
		path: '/pages/commodity/list',
		name: 'commodity_list',
		component: r => require.ensure([], () => r(require('../views/pages/commodity/list'))),
		meta: {}
	},
	{ // 商品管理-商品审核
		path: '/pages/commodity/examine',
		name: 'commodity_examine',
		component: r => require.ensure([], () => r(require('../views/pages/commodity/examine'))),
		meta: {}
	},
	{ // 商品管理-商品审核
		path: '/pages/message/index',
		name: 'message',
		component: r => require.ensure([], () => r(require('../views/pages/message/index'))),
		meta: {}
	},
	{ //配置管理-轮播图
		path: '/pages/config/banner',
		name: 'banner',
		component: r => require.ensure([], () => r(require('../views/pages/config/banner'))),
		meta: {}
	},
	{ //配置管理-文字信息
		path: '/pages/config/text',
		name: 'text',
		component: r => require.ensure([], () => r(require('../views/pages/config/text'))),
		meta: {}
	},
	{ //配置管理-上传配置
		path: '/pages/config/upload',
		name: 'upload_config',
		component: r => require.ensure([], () => r(require('../views/pages/config/upload'))),
		meta: {}
	},
	{ //配置管理-短信配置
		path: '/pages/config/sms',
		name: 'sms_config',
		component: r => require.ensure([], () => r(require('../views/pages/config/sms'))),
		meta: {}
	},
	{ //配置管理-保险配置
		path: '/pages/config/insurance',
		name: 'insurance_config',
		component: r => require.ensure([], () => r(require('../views/pages/config/insurance'))),
		meta: {}
	},
	{ //配置管理-支付配置
		path: '/pages/config/payment',
		name: 'payment_config',
		component: r => require.ensure([], () => r(require('../views/pages/config/payment'))),
		meta: {}
	},
	{ //配置管理-IM配置
		path: '/pages/config/im',
		name: 'im_config',
		component: r => require.ensure([], () => r(require('../views/pages/config/im'))),
		meta: {}
	},
	{ //仲裁管理
		path: '/pages/arbitration/list',
		name: 'arbitration',
		component: r => require.ensure([], () => r(require('../views/pages/arbitration/list'))),
		meta: {}
	},
	{ //资金管理-收益列表
		path: '/pages/capital/list',
		name: 'capital_list',
		component: r => require.ensure([], () => r(require('../views/pages/capital/list'))),
		meta: {}
	},
	{ //资金管理-提现审核
		path: '/pages/capital/withdrawal',
		name: 'capital_withdrawal',
		component: r => require.ensure([], () => r(require('../views/pages/capital/withdrawal'))),
		meta: {}
	},
	{ //客服聊天
		path: '/pages/chat/index',
		name: 'chat',
		component: r => require.ensure([], () => r(require('../views/pages/chat/index'))),
		meta: {}
	},
	{ //聊天记录管理
		path: '/pages/chat/record',
		name: 'chat_record',
		component: r => require.ensure([], () => r(require('../views/pages/chat/record'))),
		meta: {}
	},
	{ //系统管理-菜单管理
		path: '/system/menu',
		name: 'system_menu',
		component: r => require.ensure([], () => r(require('../views/pages/system/menu'))),
		meta: {}
	},
	{ //系统管理-权限管理
		path: '/system/permission',
		name: 'system_permission',
		component: r => require.ensure([], () => r(require('../views/pages/system/permission'))),
		meta: {}
	},
	{ //系统管理-管理员管理
		path: '/system/admin',
		name: 'system_admin',
		component: r => require.ensure([], () => r(require('../views/pages/user/list'))),
		meta: {}
	},
	{ //系统管理-角色管理
		path: '/system/role',
		name: 'system_role',
		component: r => require.ensure([], () => r(require('../views/pages/system/role'))),
		meta: {}
	},
	// { //系统配置-订单配置
	// 	path: '/config/order',
	// 	name: 'config_order',
	// 	component: r => require.ensure([], () => r(require('../views/pages/config/order'))),
	// 	meta: {}
	// },
	{ //系统配置-保险配置(已存在,不需要重复)
		path: '/config/insurance',
		name: 'config_insurance_alt',
		component: r => require.ensure([], () => r(require('../views/pages/config/insurance'))),
		meta: {}
	},
	{ //系统配置-网站配置
		path: '/system/website',
		name: 'system_website',
		component: r => require.ensure([], () => r(require('../views/pages/system/website'))),
		meta: {}
	},
	{ //游戏管理-客户端列表
		path: '/pages/game/client',
		name: 'game_client',
		component: r => require.ensure([], () => r(require('../views/pages/game/client'))),
		meta: {
			title: '客户端列表'
		}
	},
	{ //游戏管理-区服列表
		path: '/pages/game/territory',
		name: 'game_territory',
		component: r => require.ensure([], () => r(require('../views/pages/game/territory'))),
		meta: {
			title: '区服列表'
		}
	},
	{ //系统管理-商务列表
		path: '/pages/system/business',
		name: 'system_business',
		component: r => require.ensure([], () => r(require('../views/pages/system/business'))),
		meta: {
			title: '商务列表'
		}
	},
	{ //订单管理-收货列表
		path: '/pages/receipt/list',
		name: 'receipt_list',
		component: r => require.ensure([], () => r(require('../views/pages/receipt/list'))),
		meta: {
			title: '收货列表'
		}
	},
	{ //权限管理-权限列表
		path: '/pages/auth/list',
		name: 'auth_list',
		component: r => require.ensure([], () => r(require('../views/pages/auth/list'))),
		meta: {
			title: '权限列表'
		}
	}
]

const path = []
// 首页
path.push({
	path: Config.route.index,
	name: 'index',
	component: r => require.ensure([], () => r(require('../views/set/admin/index')))
})
// 403权限不足页面
path.push({
	path: Config.route.error403,
	name: 'error403',
	component: r => require.ensure([], () => r(require('../views/error/403')))
})
// 404页面不存在
path.push({
	path: Config.route.error404,
	name: 'error404',
	component: r => require.ensure([], () => r(require('../views/error/404')))
})
// 服务端错误
path.push({
	path: Config.route.error500,
	name: 'error500',
	component: r => require.ensure([], () => r(require('../views/error/500')))
})

// 动态加载
path.push({
	path: '/',
	name: 'Layout',
	component: r => require.ensure([], () => r(require('../views/layout'))),
	children: children
})

// 拦截所有不存在的路由到登录页
// 拦截不存在的路由，跳转到登录首页
path.push({
	path: '*',
	redirect: Config.route.error404,
	name: 'to404',
	component: r => require.ensure([], () => r(require('../views/error/404')))
})

export default path;



// WEBPACK FOOTER //
// ./src/router/index.js